import { render, staticRenderFns } from "./addQuote.vue?vue&type=template&id=55c1ae04"
import script from "./addQuote.vue?vue&type=script&lang=js"
export * from "./addQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports